export const WMS_ZONE_LOADING = "WMS_ZONE_LOADING";
export const WMS_ZONE_LIMIT = 'WMS_ZONE_LIMIT'
export const WMS_ZONE_REFRESH_ZONE = "WMS_ZONE_REFRESH_ZONE";
export const WMS_ZONE_REFRESH_SELECT_ZONE_INDEX = "WMS_ZONE_REFRESH_SELECT_ZONE_INDEX";
export const WMS_ZONE_REFRESH_SELECT_ZONE_ID = "WMS_ZONE_REFRESH_SELECT_ZONE_ID";
export const WMS_ZONE_REFRESH_SELECT_SHOW_ZONE_LIST = "WMS_ZONE_REFRESH_SELECT_SHOW_ZONE_LIST";
export const WMS_ZONE_REFRESH_FILTER_VIEWPORT_FLAG = "WMS_ZONE_REFRESH_FILTER_VIEWPORT_FLAG";
export const WMS_ZONE_REFRESH_DETAIL_VIEWPORT_FLAG = "WMS_ZONE_REFRESH_DETAIL_VIEWPORT_FLAG";//模态框打开时初始化地图的中心点和坐标.
export const WMS_ZONE_REFRESH_LOCATION_RANG_LIST = "WMS_ZONE_REFRESH_LOCATION_RANG_LIST";//房源筛选详情里的项目坐标。
export const WMS_ZONE_REFRESH_DETAIL_SELECT_TAB_KEY = "WMS_ZONE_REFRESH_DETAIL_SELECT_TAB_KEY";//模态框打开时显示的Tab.
export const WMS_ZONE_REFRESH_DETAIL_SIMPLE_VERSION_SELECT_TAB_KEY = "WMS_ZONE_REFRESH_DETAIL_SIMPLE_VERSION_SELECT_TAB_KEY";
export const WMS_ZONE_REFRESH_CUSTOM_FIELD_LIST = "WMS_ZONE_REFRESH_CUSTOM_FIELD_LIST";
export const WMS_ZONE_REFRESH_EDIT_CUSTOM_FIELD_LIST = "WMS_ZONE_REFRESH_EDIT_CUSTOM_FIELD_LIST";
export const WMS_ZONE_TOGGLE_EDIT_CUSTOM_FIELD_LIST_MODAL = "WMS_ZONE_TOGGLE_EDIT_CUSTOM_FIELD_LIST_MODAL";
export const WMS_ZONE_REFRESH_CITY_NAME = "WMS_ZONE_REFRESH_CITY_NAME";
export const WMS_ZONE_MAP_REFRESH_SHOW_POINT_FLAG = "WMS_ZONE_MAP_REFRESH_SHOW_POINT_FLAG";
export const WMS_ZONE_MAP_REFRESH_ZONE_LIST = "WMS_ZONE_MAP_REFRESH_ZONE_LIST";
export const WMS_ZONE_MAP_REFRESH_SELECTED_ZONE_ID = "WMS_ZONE_MAP_REFRESH_SELECTED_ZONE_ID";
export const WMS_ZONE_REFRESH_CURRENT_LOCATION = "WMS_ZONE_REFRESH_CURRENT_LOCATION";
export const WMS_ZONE_REFRESH_COORDINATE_MAP = "WMS_ZONE_REFRESH_COORDINATE_MAP";



export const WMS_ZONE_MAP_REFRESH_SELECTED_DISTRICT_LIST = "WMS_ZONE_MAP_REFRESH_SELECTED_DISTRICT_LIST";
export const WMS_ZONE_MAP_REFRESH_SUMMARY_DISTRICT_WITH_CONDITION = "WMS_ZONE_MAP_REFRESH_SUMMARY_DISTRICT_WITH_CONDITION";
export const WMS_ZONE_MAP_REFRESH_SUMMARY_DISTRICT = "WMS_ZONE_MAP_REFRESH_SUMMARY_DISTRICT";
export const WMS_ZONE_REFRESH_ALL_COUNTIES = "WMS_ZONE_REFRESH_ALL_COUNTIES";

export const WMS_ZONE_REFRESH_ZONE_COUNT_BY_CONDITION = "WMS_ZONE_REFRESH_ZONE_COUNT_BY_CONDITION";
export const WMS_ZONE_REFRESH_BRAND_LIST = "WMS_ZONE_REFRESH_BRAND_LIST";
export const WMS_ZONE_REFRESH_ALL_TOWN_LIST = "WMS_ZONE_REFRESH_ALL_TOWN_LIST";
export const WMS_ZONE_LIST_REFRESH_SCROLL_TOP = "WMS_ZONE_LIST_REFRESH_SCROLL_TOP";
export const WMS_ZONE_MAP_REFRESH_CENTER_ZOOM = "WMS_ZONE_MAP_REFRESH_CENTER_ZOOM";
export const WMS_ZONE_SEARCH_FUZZY_BAMP_SEARCH_RESULT = "WMS_ZONE_SEARCH_FUZZY_BAMP_SEARCH_RESULT";






export const WMS_ZONE_REFRESH_MAP_LOCATION = "WMS_ZONE_REFRESH_MAP_LOCATION";

export const WMS_ZONE_REFRESH_READ_ZONE_LIST = "WMS_ZONE_REFRESH_READ_ZONE_LIST";
export const WMS_ZONE_REFRESH_EXPORT_ZONE_LIST = "WMS_ZONE_REFRESH_EXPORT_ZONE_LIST";

export const WMS_ZONE_REFRESH_ZONE_LIST = "WMS_ZONE_REFRESH_ZONE_LIST";
export const WMS_ZONE_REFRESH_FILTER_ZONE_LIST = "WMS_ZONE_REFRESH_FILTER_ZONE_LIST";

export const WMS_ZONE_LIST = "WMS_ZONE_LIST";
export const WMS_EMPTY_ZONE_LIST = "WMS_EMPTY_ZONE_LIST";
export const WMS_FILTER_ZONE_LIST = "WMS_FILTER_ZONE_LIST";
export const WMS_LIST_ZONE_LIST = "WMS_LIST_ZONE_LIST";

export const WMS_ZONE_REFRESH_SEARCH_CONDITION = "WMS_ZONE_REFRESH_SEARCH_CONDITION";
export const WMS_ZONE_FILTER_REFRESH_SEARCH_CONDITION = "WMS_ZONE_FILTER_REFRESH_SEARCH_CONDITION";

export const WMS_ZONE_REFRESH_SHOW_MAP = "WMS_ZONE_REFRESH_SHOW_MAP";
export const WMS_ZONE_TOGGLE_DETAIL_MODAL = "WMS_ZONE_TOGGLE_DETAIL_MODAL";
export const WMS_ZONE_TOGGLE_ZONE_PHOTO_MODAL = "WMS_ZONE_TOGGLE_ZONE_PHOTO_MODAL";
export const WMS_ZONE_TOGGLE_ZONE_PHOTO_BATCH_ADD_MODAL = "WMS_ZONE_TOGGLE_ZONE_PHOTO_BATCH_ADD_MODAL";
export const WMS_ZONE_TOGGLE_ZONE_FILE_BATCH_ADD_MODAL = "WMS_ZONE_TOGGLE_ZONE_FILE_BATCH_ADD_MODAL";
export const WMS_ZONE_REFRESH_SELECTED_ZONE_PHOTO_BATCH_ADD = "WMS_ZONE_REFRESH_SELECTED_ZONE_PHOTO_BATCH_ADD";
export const WMS_ZONE_REFRESH_SELECTED_ZONE_FILE_BATCH_ADD = "WMS_ZONE_REFRESH_SELECTED_ZONE_FILE_BATCH_ADD";
export const WMS_ZONE_REFRESH_SELECTED_ZONE_PHOTO = "WMS_ZONE_REFRESH_SELECTED_ZONE_PHOTO";
export const WMS_ZONE_TOGGLE_ZONE_FILE_MODAL = "WMS_ZONE_TOGGLE_ZONE_FILE_MODAL";
export const WMS_ZONE_TOGGLE_SHARE_TRACE_MODAL = "WMS_ZONE_TOGGLE_SHARE_TRACE_MODAL";

export const WMS_ZONE_REFRESH_ZONE_FILE_MAP_SEARCH = "WMS_ZONE_REFRESH_ZONE_FILE_MAP_SEARCH";
export const WMS_ZONE_REFRESH_ZONE_FILTER_MAP_SEARCH_RESULT_LIST = "WMS_ZONE_REFRESH_ZONE_FILTER_MAP_SEARCH_RESULT_LIST";
export const WMS_ZONE_REFRESH_ZONE_FILTER_MAP_SEARCH_RESULT_VALUE = "WMS_ZONE_REFRESH_ZONE_FILTER_MAP_SEARCH_RESULT_VALUE";

export const WMS_ZONE_REFRESH_SELECTED_ZONE_FILE = "WMS_ZONE_REFRESH_SELECTED_ZONE_FILE";

export const WMS_ZONE_BRAND_LIST = "WMS_ZONE_BRAND_LIST";
export const WMS_ZONE_LESSOR_COMPANY_LIST = "WMS_ZONE_LESSOR_COMPANY_LIST";
export const WMS_ZONE_COORDINATE_LIST = "WMS_ZONE_COORDINATE_LIST";
export const WMS_ZONE_BAIDU_SEARCH_RESULT = "WMS_ZONE_BAIDU_SEARCH_RESULT";

//房源详情-坐标
export const WMS_ZONE_REFRESH_ZONE_LOCATION_SEARCH_RESULT = "WMS_ZONE_REFRESH_ZONE_LOCATION_SEARCH_RESULT";
export const WMS_ZONE_REFRESH_ZONE_LOCATION_SEARCH_AND_POINT = "WMS_ZONE_REFRESH_ZONE_LOCATION_SEARCH_AND_POINT";


export const WMS_ZONE_BAIDU_BMAP_REFRESH_RECTANGLE_CENTER_POINT = "WMS_ZONE_BAIDU_BMAP_REFRESH_RECTANGLE_CENTER_POINT";
export const WMS_ZONE_BAIDU_BMAP_REFRESH_RECTANGLE_SHOW_VALUE = "WMS_ZONE_BAIDU_BMAP_REFRESH_RECTANGLE_SHOW_VALUE";

export const WMS_ZONE_TOGGLE_SELECT_LESSOR_CONTACT_MODAL = "WMS_ZONE_TOGGLE_SELECT_LESSOR_CONTACT_MODAL";
export const WMS_ZONE_LESSOR_CONTACT_LIST = "WMS_ZONE_LESSOR_CONTACT_LIST";

export const WMS_ZONE_TOGGLE_ADD_CONTACT_RELATION_MODAL = "WMS_ZONE_TOGGLE_ADD_CONTACT_RELATION_MODAL";
export const WMS_ZONE_REFRESH_CONTACT_RELATION = "WMS_ZONE_REFRESH_CONTACT_RELATION";

export const WMS_ZONE_REFRESH_FILTER_CONTACT_SEARCH_CONDITION = "WMS_ZONE_REFRESH_FILTER_CONTACT_SEARCH_CONDITION";
export const WMS_ZONE_SEARCH_FILTER_LESSOR_CONTACT_LIST = "WMS_ZONE_SEARCH_FILTER_LESSOR_CONTACT_LIST";
export const WMS_ZONE_REFRESH_LESSOR_CONTACT_LIST = "WMS_ZONE_REFRESH_LESSOR_CONTACT_LIST";

//房源创建
export const WMS_ZONE_REFRESH_ZONE_SHOW_CREATE_MAP = "WMS_ZONE_REFRESH_ZONE_SHOW_CREATE_MAP";
export const WMS_ZONE_REFRESH_CREATE_SHOW_ZONE_LIST = "WMS_ZONE_REFRESH_CREATE_SHOW_ZONE_LIST";
export const WMS_ZONE_REFRESH_CREATE_SEARCH_RESULT = "WMS_ZONE_REFRESH_CREATE_SEARCH_RESULT";
export const WMS_ZONE_REFRESH_CREATE_SEARCH_AND_POINT = "WMS_ZONE_REFRESH_CREATE_SEARCH_AND_POINT";

//我的收藏
export const WMS_ZONE_FAVORITES_LOADING = 'WMS_ZONE_FAVORITES_LOADING';
export const WMS_ZONE_FAVORITES_REFRESH_SEARCH_CONDITION = 'WMS_ZONE_FAVORITES_REFRESH_SEARCH_CONDITION';
export const WMS_ZONE_FAVORITES_SEARCH_LIST = 'WMS_ZONE_FAVORITES_SEARCH_LIST';
export const WMS_ZONE_REFRESH_PROPOSAL_GROUP = "WMS_ZONE_REFRESH_PROPOSAL_GROUP";
export const WMS_ZONE_REFRESH_RESEARCH_PROPOSAL_LIST = "WMS_ZONE_REFRESH_RESEARCH_PROPOSAL_LIST";
export const WMS_ZONE_REFRESH_SHOW_MAP_FLAG = "WMS_ZONE_REFRESH_SHOW_MAP_FLAG";
export const WMS_ZONE_REFRESH_SHOW_DRAW_FLAG = "WMS_ZONE_REFRESH_SHOW_DRAW_FLAG";
export const WMS_ZONE_REFRESH_TOOL_TYPE = "WMS_ZONE_REFRESH_TOOL_TYPE";
export const WMS_ZONE_REFRESH_MAP_SEARCH_RESULT = "WMS_ZONE_REFRESH_MAP_SEARCH_RESULT";
export const WMS_ZONE_REFRESH_IS_LOCATION_MODAL_SHOW = "WMS_ZONE_REFRESH_IS_LOCATION_MODAL_SHOW";

export const WMS_BUILDING_LOADING = "WMS_BUILDING_LOADING";
export const WMS_BUILDING_REFRESH_BUILDING = "WMS_BUILDING_REFRESH_BUILDING";
export const WMS_BUILDING_LIST = "WMS_BUILDING_LIST";
export const WMS_BUILDING_TOGGLE_DETAIL_MODAL = "WMS_BUILDING_TOGGLE_DETAIL_MODAL";
export const WMS_BUILDING_STARTING_VALUE = "WMS_BUILDING_STARTING_VALUE";
export const WMS_BUILDING_REFRESH_BUILDING_POINT_LIST = "WMS_BUILDING_REFRESH_BUILDING_POINT_LIST";//房源筛选详情里的物业坐标。

export const WMS_LEASE_LOADING = "WMS_LEASE_LOADING";
export const WMS_LEASE_REFRESH_LEASE = "WMS_LEASE_REFRESH_LEASE";
export const WMS_LEASE_LIST = "WMS_LEASE_LIST";
export const WMS_LEASE_TOGGLE_DETAIL_MODAL = "WMS_LEASE_TOGGLE_DETAIL_MODAL";
export const WMS_LEASE_REFRESH_LEASE_LIST = "WMS_LEASE_REFRESH_LEASE_LIST";

export const WMS_LEASE_TOGGLE_LEASE_CALCULATION_MODAL = "WMS_LEASE_TOGGLE_LEASE_CALCULATION_MODAL";
export const WMS_LEASE_REFRESH_CALCULATE_LEASE = "WMS_LEASE_REFRESH_CALCULATE_LEASE";

//出租方品牌，租户品牌
export const WMS_BRAND_LOADING = 'WMS_BRAND_LOADING';
export const WMS_BRAND_SEARCH_LIST = 'WMS_BRAND_SEARCH_LIST';
export const WMS_BRAND_SEARCH_ALL_LIST = 'WMS_BRAND_SEARCH_ALL_LIST';
export const WMS_BRAND_REFRESH_BRAND = 'WMS_BRAND_REFRESH_BRAND';
export const WMS_BRAND_TOGGLE_DETAIL_MODAL = "WMS_BRAND_TOGGLE_DETAIL_MODAL";
export const WMS_BRAND_REFRESH_SEARCH_CONDITION = "WMS_BRAND_REFRESH_SEARCH_CONDITION";

//出租方公司，租户公司
export const WMS_COMPANY_LOADING = 'WMS_COMPANY_LOADING';
export const WMS_COMPANY_SEARCH_LIST = 'WMS_COMPANY_SEARCH_LIST';
export const WMS_COMPANY_SEARCH_ALL_LIST = 'WMS_COMPANY_SEARCH_ALL_LIST';
export const WMS_COMPANY_REFRESH_COMPANY = 'WMS_COMPANY_REFRESH_COMPANY';
export const WMS_COMPANY_TOGGLE_DETAIL_MODAL = "WMS_COMPANY_TOGGLE_DETAIL_MODAL";
export const WMS_COMPANY_REFRESH_SEARCH_CONDITION = "WMS_COMPANY_REFRESH_SEARCH_CONDITION";
export const WMS_COMPANY_SEARCH_MAIN_COMPANY = 'WMS_COMPANY_SEARCH_MAIN_COMPANY';

//出租方联系人，租户联系人
export const WMS_CONTACT_LOADING = 'WMS_CONTACT_LOADING';
export const WMS_CONTACT_SEARCH_LIST = 'WMS_CONTACT_SEARCH_LIST';
// export const WMS_CONTACT_SEARCH_ALL_LIST = 'WMS_CONTACT_SEARCH_ALL_LIST';
export const WMS_CONTACT_REFRESH_CONTACT = 'WMS_CONTACT_REFRESH_CONTACT';
export const WMS_CONTACT_TOGGLE_DETAIL_MODAL = "WMS_CONTACT_TOGGLE_DETAIL_MODAL";
export const WMS_CONTACT_REFRESH_DETAIL_MODAL_INFO = "WMS_CONTACT_REFRESH_DETAIL_MODAL_INFO";

export const WMS_CONTACT_REFRESH_SEARCH_CONDITION = "WMS_CONTACT_REFRESH_SEARCH_CONDITION";
export const WMS_CONTACT_REFRESH_CLASSIFY = "WMS_CONTACT_REFRESH_CLASSIFY";
export const WMS_CONTACT_SEARCH_ZONE_LIST = 'WMS_CONTACT_SEARCH_ZONE_LIST';
export const WMS_CONTACT_TOGGLE_BINDING_ZONE_MODAL = "WMS_CONTACT_TOGGLE_BINDING_ZONE_MODAL";
export const WMS_CONTACT_TOGGLE_SELECT_CONTACTS_MODAL = "WMS_CONTACT_TOGGLE_SELECT_CONTACTS_MODAL";
export const WMS_CONTACT_REFRESH_SELECT_CONTACTS_MODAL_INFO = "WMS_CONTACT_REFRESH_SELECT_CONTACTS_MODAL_INFO";


//方案组
export const WMS_PROPOSAL_GROUP_LOADING = "WMS_PROPOSAL_GROUP_LOADING";
export const WMS_PROPOSAL_GROUP_REFRESH_GROUP = "WMS_PROPOSAL_GROUP_REFRESH_GROUP";
export const WMS_PROPOSAL_GROUP_REFRESH_GROUP_LIST = "WMS_PROPOSAL_GROUP_REFRESH_GROUP_LIST";
export const WMS_PROPOSAL_GROUP_REFRESH_ORIGINAL_POINT_LIST = "WMS_PROPOSAL_GROUP_REFRESH_ORIGINAL_POINT_LIST";
export const WMS_PROPOSAL_GROUP_REFRESH_SEARCH_LIST = "WMS_PROPOSAL_GROUP_REFRESH_SEARCH_LIST";
export const WMS_PROPOSAL_GROUP_REFRESH_DISTRICT_GROUP_MAP = "WMS_PROPOSAL_GROUP_REFRESH_DISTRICT_GROUP_MAP";
export const WMS_PROPOSAL_GROUP_REFRESH_SELECT_GROUP = "WMS_PROPOSAL_GROUP_REFRESH_SELECT_GROUP";
export const WMS_PROPOSAL_GROUP_REFRESH_AD_ZONE_LIST = "WMS_PROPOSAL_GROUP_REFRESH_AD_ZONE_LIST";
export const WMS_PROPOSAL_GROUP_TOGGLE_AD_ZONE_LIST_MODAL = "WMS_PROPOSAL_GROUP_TOGGLE_AD_ZONE_LIST_MODAL";



export const WMS_PROPOSAL_GROUP_REFRESH_SEARCH_CONDITION = "WMS_PROPOSAL_GROUP_REFRESH_SEARCH_CONDITION";
export const WMS_PROPOSAL_GROUP_TOGGLE_SELECT_MODAL = "WMS_PROPOSAL_GROUP_TOGGLE_SELECT_MODAL";
export const WMS_PROPOSAL_GROUP_TOGGLE_ORIGINAL_POINT_MODAL = "WMS_PROPOSAL_GROUP_TOGGLE_ORIGINAL_POINT_MODAL";
export const WMS_PROPOSAL_GROUP_TOGGLE_DETAIL_MODAL = "WMS_PROPOSAL_GROUP_TOGGLE_DETAIL_MODAL";
export const WMS_PROPOSAL_GROUP_TOGGLE_CARD_MODAL = "WMS_PROPOSAL_GROUP_TOGGLE_CARD_MODAL";

export const WMS_PROPOSAL_LOADING = "WMS_PROPOSAL_LOADING";
export const WMS_PROPOSAL_REFRESH_PROPOSAL = "WMS_PROPOSAL_REFRESH_PROPOSAL";
export const WMS_PROPOSAL_REFRESH_SEARCH_LIST = "WMS_PROPOSAL_REFRESH_SEARCH_LIST";
export const WMS_PROPOSAL_REFRESH_SEARCH_CONDITION = "WMS_PROPOSAL_REFRESH_SEARCH_CONDITION";
export const WMS_PROPOSAL_TOGGLE_ZONE_MODAL = "WMS_PROPOSAL_TOGGLE_ZONE_MODAL";
export const WMS_PROPOSAL_GROUP_TOGGLE_ZONE_TAG_SETTING_MODAL = "WMS_PROPOSAL_GROUP_TOGGLE_ZONE_TAG_SETTING_MODAL";

export const WMS_PROPOSAL_TOGGLE_PROPOSAL_PREVIEW_MODAL = "WMS_PROPOSAL_TOGGLE_PROPOSAL_PREVIEW_MODAL";
export const WMS_PROPOSAL_TOGGLE_PROPOSAL_IMPROPER_MODAL = "WMS_PROPOSAL_TOGGLE_PROPOSAL_IMPROPER_MODAL";
export const WMS_PROPOSAL_REFRESH_PROPOSAL_IMPROPER = "WMS_PROPOSAL_REFRESH_PROPOSAL_IMPROPER";
export const WMS_PROPOSAL_REFRESH_VIEWPORT_FLAG = "WMS_PROPOSAL_REFRESH_VIEWPORT_FLAG";//方案比较地图的初始化地图的中心点和坐标.

export const WMS_PROPOSAL_REFRESH_PROPOSAL_PREVIEW = "WMS_PROPOSAL_REFRESH_PROPOSAL_PREVIEW";
export const WMS_PROPOSAL_TOGGLE_PROPOSAL_SORT_MODAL = "WMS_PROPOSAL_TOGGLE_PROPOSAL_SORT_MODAL";
export const WMS_PROPOSAL_TOGGLE_PROPOSAL_FIELD_SORT_MODAL = "WMS_PROPOSAL_TOGGLE_PROPOSAL_FIELD_SORT_MODAL";

export const WMS_FOLLOWUP_LOADING = "WMS_FOLLOWUP_LOADING";
export const WMS_FOLLOWUP_REFRESH_SEARCH_CONDITION = "WMS_FOLLOWUP_REFRESH_SEARCH_CONDITION";
export const WMS_FOLLOWUP_LIST = "WMS_FOLLOWUP_LIST";
export const WMS_FOLLOWUP_TOGGLE_DETAIL_MODAL = "WMS_FOLLOWUP_TOGGLE_DETAIL_MODAL";
export const WMS_FOLLOWUP_REFRESH_FOLLOWUP = "WMS_FOLLOWUP_REFRESH_FOLLOWUP";
export const WMS_FOLLOWUP_REFRESH_FOLLOWUP_LIST = "WMS_FOLLOWUP_REFRESH_FOLLOWUP_LIST";

//商机
export const WMS_BUSINESS_OPPORTUNITY_LOADING = 'WMS_BUSINESS_OPPORTUNITY_LOADING';
export const WMS_BUSINESS_OPPORTUNITY_SEARCH_LIST = 'WMS_BUSINESS_OPPORTUNITY_SEARCH_LIST';
export const WMS_BUSINESS_OPPORTUNITY_DISCARD_RESULT_SEARCH_LIST = 'WMS_BUSINESS_OPPORTUNITY_DISCARD_RESULT_SEARCH_LIST';
export const WMS_BUSINESS_OPPORTUNITY_REFRESH_OPPORTUNITY = 'WMS_BUSINESS_OPPORTUNITY_REFRESH_OPPORTUNITY';
export const WMS_BUSINESS_OPPORTUNITY_REFRESH_SEARCH_CONDITION = "WMS_BUSINESS_OPPORTUNITY_REFRESH_SEARCH_CONDITION";
export const WMS_BUSINESS_OPPORTUNITY_DISCARD_RESULT_SEARCH_CONDITION = 'WMS_BUSINESS_OPPORTUNITY_DISCARD_RESULT_SEARCH_CONDITION';
export const WMS_BUSINESS_OPPORTUNITY_TOGGLE_FIELD_SORT_MODAL = "WMS_BUSINESS_OPPORTUNITY_TOGGLE_FIELD_SORT_MODAL";
export const WMS_BUSINESS_OPPORTUNITY_REFRESH_BUSINESS_CONTACTS = "WMS_BUSINESS_OPPORTUNITY_REFRESH_BUSINESS_CONTACTS";
export const WMS_BUSINESS_OPPORTUNITY_SHOW_BUSINESS_CONTACTS_MODAL = "WMS_BUSINESS_OPPORTUNITY_SHOW_BUSINESS_CONTACTS_MODAL";
export const WMS_BUSINESS_OPPORTUNITY_REFRESH_DISCARD_REASON_MODAL = "WMS_BUSINESS_OPPORTUNITY_REFRESH_DISCARD_REASON_MODAL";
export const WMS_BUSINESS_OPPORTUNITY_DISCARD_RESULT_SEARCH_RESULT_TABLE = 'WMS_BUSINESS_OPPORTUNITY_DISCARD_RESULT_SEARCH_RESULT_TABLE';
export const WMS_BUSINESS_OPPORTUNITY_TOGGLE_SHARE_LIST_MODAL = "WMS_BUSINESS_OPPORTUNITY_TOGGLE_SHARE_LIST_MODAL";

export const WMS_BUSINESS_OPPORTUNITY_REFRESH_FOLLOWERS = "WMS_BUSINESS_OPPORTUNITY_REFRESH_FOLLOWERS";
export const WMS_BUSINESS_OPPORTUNITY_TOGGLE_SELECT_OPPORTUNITY_MODAL = "WMS_BUSINESS_OPPORTUNITY_TOGGLE_SELECT_OPPORTUNITY_MODAL";
export const WMS_BUSINESS_OPPORTUNITY_REFRESH_POINT_MODAL = "WMS_BUSINESS_OPPORTUNITY_REFRESH_POINT_MODAL";
export const WMS_BUSINESS_OPPORTUNITY_REFRESH_POINT_LIST = "WMS_BUSINESS_OPPORTUNITY_REFRESH_POINT_LIST";
export const WMS_BUSINESS_OPPORTUNITY_REFRESH_FIELD_LIST = "WMS_BUSINESS_OPPORTUNITY_REFRESH_FIELD_LIST";
export const WMS_BUSINESS_OPPORTUNITY_REFRESH_FIELD_EDIT_FLAG = "WMS_BUSINESS_OPPORTUNITY_REFRESH_FIELD_EDIT_FLAG";

export const WMS_BUSINESS_OPPORTUNITY_REFRESH_SCHEDULERS = "WMS_BUSINESS_OPPORTUNITY_REFRESH_SCHEDULERS";
//商机的带看
export const WMS_BUSINESS_SCHEDULER_LOADING = 'WMS_BUSINESS_SCHEDULER_LOADING';
export const WMS_BUSINESS_SCHEDULER_REFRESH_SCHEDULER = "WMS_BUSINESS_SCHEDULER_REFRESH_SCHEDULER";
export const WMS_BUSINESS_SCHEDULER_TOGGLE_DETAIL_MODAL = "WMS_BUSINESS_SCHEDULER_TOGGLE_DETAIL_MODAL";
export const WMS_BUSINESS_SCHEDULER_TOGGLE_SELECT_ZONE_MODAL = "WMS_BUSINESS_SCHEDULER_TOGGLE_SELECT_ZONE_MODAL";
export const WMS_BUSINESS_SCHEDULER_TOGGLE_CARD_MODAL = "WMS_BUSINESS_SCHEDULER_TOGGLE_CARD_MODAL";

export const WMS_BUSINESS_SCHEDULER_TOGGLE_CHANGE_ZONE_CONTACTS_MODAL = "WMS_BUSINESS_SCHEDULER_TOGGLE_CHANGE_ZONE_CONTACTS_MODAL";
export const WMS_BUSINESS_SCHEDULER_REFRESH_CONTACTS = "WMS_BUSINESS_SCHEDULER_REFRESH_CONTACTS";
export const WMS_BUSINESS_SCHEDULER_TOGGLE_NOTICE_MODAL = "WMS_BUSINESS_SCHEDULER_TOGGLE_NOTICE_MODAL";
export const WMS_BUSINESS_SCHEDULER_TOGGLE_MAIL_HISTORY_MODAL = "WMS_BUSINESS_SCHEDULER_TOGGLE_MAIL_HISTORY_MODAL";
export const WMS_BUSINESS_SCHEDULER_TOGGLE_PREVIEW_MODAL = "WMS_BUSINESS_SCHEDULER_TOGGLE_PREVIEW_MODAL";

export const WMS_BUSINESS_SCHEDULER_SEARCH_LIST = 'WMS_BUSINESS_SCHEDULER_SEARCH_LIST';
export const WMS_BUSINESS_SCHEDULER_REFRESH_SEARCH_CONDITION = "WMS_BUSINESS_SCHEDULER_REFRESH_SEARCH_CONDITION";
export const WMS_BUSINESS_SCHEDULER_REFRESH_DRIVER_DISTANCE_MAP = 'WMS_BUSINESS_SCHEDULER_REFRESH_DRIVER_DISTANCE_MAP';

export const WMS_BUSINESS_SCHEDULER_REFRESH_SCHEDULER_ITEM_INDEX = "WMS_BUSINESS_SCHEDULER_REFRESH_INTENTION_ITEM_INDEX";
//商机的意向
export const WMS_BUSINESS_INTENTION_LOADING = 'WMS_BUSINESS_INTENTION_LOADING';
export const WMS_BUSINESS_INTENTION_REFRESH_INTENTION = "WMS_BUSINESS_INTENTION_REFRESH_INTENTION";
export const WMS_BUSINESS_INTENTION_TOGGLE_DETAIL_MODAL = "WMS_BUSINESS_INTENTION_TOGGLE_DETAIL_MODAL";
export const WMS_BUSINESS_INTENTION_TOGGLE_SELECT_ZONE_MODAL = "WMS_BUSINESS_INTENTION_TOGGLE_SELECT_ZONE_MODAL";
export const WMS_BUSINESS_INTENTION_TOGGLE_CARD_MODAL = "WMS_BUSINESS_INTENTION_TOGGLE_CARD_MODAL";
export const WMS_BUSINESS_INTENTION_REFRESH_INTENTIONS = "WMS_BUSINESS_INTENTION_REFRESH_INTENTIONS";

export const WMS_BUSINESS_INTENTION_TOGGLE_CHANGE_ZONE_CONTACTS_MODAL = "WMS_BUSINESS_INTENTION_TOGGLE_CHANGE_ZONE_CONTACTS_MODAL";
export const WMS_BUSINESS_INTENTION_REFRESH_CONTACTS = "WMS_BUSINESS_INTENTION_REFRESH_CONTACTS";
export const WMS_BUSINESS_INTENTION_TOGGLE_NOTICE_MODAL = "WMS_BUSINESS_INTENTION_TOGGLE_NOTICE_MODAL";
export const WMS_BUSINESS_INTENTION_TOGGLE_MAIL_HISTORY_MODAL = "WMS_BUSINESS_INTENTION_TOGGLE_MAIL_HISTORY_MODAL";
export const WMS_BUSINESS_INTENTION_TOGGLE_CREATE_SELECT_PROPOSAL_MODAL = "WMS_BUSINESS_INTENTION_TOGGLE_CREATE_SELECT_PROPOSAL_MODAL";

export const WMS_BUSINESS_INTENTION_TOGGLE_LETTER_MODAL = "WMS_BUSINESS_INTENTION_TOGGLE_LETTER_MODAL";
// export const WMS_BUSINESS_INTENTION_TOGGLE_LETTER_MODAL= "WMS_BUSINESS_INTENTION_TOGGLE_LETTER_MODAL";
export const WMS_BUSINESS_INTENTION_TOGGLE_LETTER_FORM_MODAL = "WMS_BUSINESS_INTENTION_TOGGLE_LETTER_FORM_MODAL";

export const WMS_BUSINESS_INTENTION_REFRESH_LETTER_EDITOR = "WMS_BUSINESS_INTENTION_REFRESH_LETTER_EDITOR";
export const WMS_BUSINESS_INTENTION_REFRESH_LETTER_FORM = "WMS_BUSINESS_INTENTION_REFRESH_LETTER_FORM";
export const WMS_BUSINESS_INTENTION_REFRESH_FROM_SCHEDULER_FLAG = "WMS_BUSINESS_INTENTION_REFRESH_FROM_SCHEDULER_FLAG";

export const WMS_BUSINESS_OPPORTUNITY_SEARCH_ZONE_LIST = "WMS_BUSINESS_OPPORTUNITY_SEARCH_ZONE_LIST";
export const WMS_BUSINESS_OPPORTUNITY_SHOW_DELETE_MODAL = "WMS_BUSINESS_OPPORTUNITY_SHOW_DELETE_MODAL";

export const WMS_SUMMARY_LOADING = "WMS_SUMMARY_LOADING";
export const WMS_SUMMARY_REFRESH_SEARCH_CONDITION = "WMS_SUMMARY_REFRESH_SEARCH_CONDITION";
export const WMS_SUMMARY_REFRESH_SEARCH_ZONE_LEVEL = "WMS_SUMMARY_REFRESH_SEARCH_ZONE_LEVEL";
export const WMS_SUMMARY_REFRESH_SEARCH_DISTRICT_LIST = "WMS_SUMMARY_REFRESH_SEARCH_DISTRICT_LIST";
//市场调研汇总
export const WMS_FOLLOW_SUMMARY_LOADING = "WMS_FOLLOW_SUMMARY_LOADING";
export const WMS_FOLLOW_SUMMARY_REFRESH_SEARCH_CONDITION = "WMS_FOLLOW_SUMMARY_REFRESH_SEARCH_CONDITION";
export const WMS_FOLLOW_SUMMARY_REFRESH_SEARCH_FOLLOW_LIST = "WMS_FOLLOW_SUMMARY_REFRESH_SEARCH_FOLLOW_LIST";
export const WMS_FOLLOW_SUMMARY_REFRESH_SHOW_SUPERVISOR_EVALUATION_MODAL = "WMS_FOLLOW_SUMMARY_REFRESH_SHOW_SUPERVISOR_EVALUATION_MODAL";
export const WMS_FOLLOW_SUMMARY_REFRESH_SUPERVISOR_EVALUATION = "WMS_FOLLOW_SUMMARY_REFRESH_SUPERVISOR_EVALUATION";

//房源跟进汇总
export const WMS_FOLLOW_SUMMARY_REFRESH_MAIL_CONDITION = "WMS_FOLLOW_SUMMARY_REFRESH_MAIL_CONDITION";
export const WMS_FOLLOW_SUMMARY_REFRESH_SEARCH_MAIL_LIST = "WMS_FOLLOW_SUMMARY_REFRESH_SEARCH_MAIL_LIST";


export const WMS_SUMMARY_REFRESH_DISTRICT_SUMMARY = "WMS_SUMMARY_REFRESH_DISTRICT_SUMMARY";
export const WMS_SUMMARY_REFRESH_DISTRICT_BRAND_SUMMARY = "WMS_SUMMARY_REFRESH_DISTRICT_BRAND_SUMMARY";
export const WMS_SUMMARY_REFRESH_ZONE_LIST = "WMS_SUMMARY_REFRESH_ZONE_LIST";
export const WMS_SUMMARY_REFRESH_REGION_ZONE_SUMMARY = "WMS_SUMMARY_REFRESH_REGION_ZONE_SUMMARY";

export const WMS_SUMMARY_REFRESH_SELECTED_ZONE_ID_MAP = "WMS_SUMMARY_REFRESH_SELECTED_ZONE_ID_MAP";
export const WMS_SUMMARY_REFRESH_EDIT_ZONE_ID_MAP = "WMS_SUMMARY_REFRESH_EDIT_ZONE_ID_MAP";

export const WMS_SUMMARY_REFRESH_EDIT_ZONE_ID_RENT_MAP = "WMS_SUMMARY_REFRESH_EDIT_ZONE_ID_RENT_MAP";

export const WMS_SUMMARY_REFRESH_FILTERED_ZONE_VALUE = "WMS_SUMMARY_REFRESH_FILTERED_ZONE_VALUE";
export const WMS_SUMMARY_REFRESH_FILTERED_ZONE_CONDITION = "WMS_SUMMARY_REFRESH_FILTERED_ZONE_CONDITION";
export const WMS_SUMMARY_REFRESH_EDIT_FILTERED_ZONE_CONDITION = "WMS_SUMMARY_REFRESH_EDIT_FILTERED_ZONE_CONDITION";

export const WMS_SUMMARY_REFRESH_DISTRICT_SECTION_LIST = "WMS_SUMMARY_REFRESH_DISTRICT_SECTION_LIST";

export const WMS_SUMMARY_TOGGLE_ZONE_FILTER_MODAL = "WMS_SUMMARY_TOGGLE_ZONE_FILTER_MODAL";
export const WMS_SUMMARY_TOGGLE_DISTRICT_SECTION_LIST_MODAL = "WMS_SUMMARY_TOGGLE_DISTRICT_SECTION_LIST_MODAL";

export const WMS_SUMMARY_TOGGLE_DISTRICT_RENT_CHANGE_MODAL = "WMS_SUMMARY_TOGGLE_DISTRICT_RENT_CHANGE_MODAL";
export const WMS_SUMMARY_REFRESH_DISTRICT_RENT_MAP = "WMS_SUMMARY_REFRESH_DISTRICT_RENT_MAP";

//土地检索数据导入
export const WMS_LAND_DATA_IMPORT_LOADING = 'WMS_LAND_DATA_IMPORT_LOADING';
export const WMS_LAND_DATA_IMPORT_REFRESH_SEARCH_CONDITION = "WMS_LAND_DATA_IMPORT_REFRESH_SEARCH_CONDITION";
export const WMS_LAND_DATA_IMPORT_SEARCH_LIST = 'WMS_LAND_DATA_IMPORT_SEARCH_LIST';
export const WMS_LAND_DATA_IMPORT_REFRESH_LAND = 'WMS_LAND_DATA_IMPORT_REFRESH_LAND';
export const WMS_LAND_DATA_IMPORT_TOGGLE_DETAIL_MODAL = 'WMS_LAND_DATA_IMPORT_TOGGLE_DETAIL_MODAL';

//市场调研管理
export const WMS_RESEARCH_REPORT_LOADING = 'WMS_RESEARCH_REPORT_LOADING';
export const WMS_RESEARCH_REPORT_REFRESH_SEARCH_CONDITION = "WMS_RESEARCH_REPORT_REFRESH_SEARCH_CONDITION";
export const WMS_RESEARCH_REPORT_SEARCH_LIST = 'WMS_RESEARCH_REPORT_SEARCH_LIST';
export const WMS_RESEARCH_REPORT_REFRESH_RESEARCH_REPORT = 'WMS_RESEARCH_REPORT_REFRESH_RESEARCH_REPORT';
export const WMS_RESEARCH_REPORT_TOGGLE_DETAIL_MODAL = 'WMS_RESEARCH_REPORT_TOGGLE_DETAIL_MODAL';
export const WMS_RESEARCH_REPORT_SHOW_DELETE_MODAL = 'WMS_RESEARCH_REPORT_SHOW_DELETE_MODAL';
export const WMS_RESEARCH_REPORT_TOGGLE_CONTACTS_MODAL = 'WMS_RESEARCH_REPORT_TOGGLE_CONTACTS_MODAL';
export const WMS_RESEARCH_REPORT_REFRESH_RESEARCH_CONTACTS = 'WMS_RESEARCH_REPORT_REFRESH_RESEARCH_CONTACTS';
export const WMS_RESEARCH_REPORT_TOGGLE_SORT_MODAL = 'WMS_RESEARCH_REPORT_TOGGLE_SORT_MODAL';


export const WMS_RESEARCH_PROPOSAL_REFRESH_RESEARCH_PROPOSAL_List = 'WMS_RESEARCH_PROPOSAL_REFRESH_RESEARCH_PROPOSAL_List';
export const WMS_RESEARCH_PROPOSAL_List_REFRESH_VIEWPORT_FLAG = 'WMS_RESEARCH_PROPOSAL_List_REFRESH_VIEWPORT_FLAG';
export const WMS_RESEARCH_EXPORT_RESEARCH_PROPOSAL_ID_LIST = 'WMS_RESEARCH_EXPORT_RESEARCH_PROPOSAL_ID_LIST';

export const WMS_RESEARCH_PROPOSAL_REFRESH_POINT_LIST = 'WMS_RESEARCH_PROPOSAL_REFRESH_POINT_LIST';
export const WMS_RESEARCH_PROPOSAL_REFRESH_POINT_MODAL = 'WMS_RESEARCH_PROPOSAL_REFRESH_POINT_MODAL';
export const WMS_RESEARCH_PROPOSAL_TOGGLE_CARD_MODAL = 'WMS_RESEARCH_PROPOSAL_TOGGLE_CARD_MODAL';

export const WMS_RESEARCH_PROPOSAL_REFRESH_PROPOSAL_EXPORT_LIST = 'WMS_RESEARCH_PROPOSAL_REFRESH_PROPOSAL_EXPORT_LIST';

//可视化管理
export const WMS_CHARTS_SUMMARY_LOADING = 'WMS_CHARTS_SUMMARY_LOADING';
export const WMS_CHARTS_SUMMARY_REFRESH_DISTRICT_SUMMARY = "WMS_CHARTS_SUMMARY_REFRESH_DISTRICT_SUMMARY";


export const WMS_SHARE_TRACE_LOADING = 'WMS_SHARE_TRACE_LOADING';
export const WMS_SHARE_TRACE_SEARCH_LIST = 'WMS_SHARE_TRACE_SEARCH_LIST';
export const WMS_SHARE_TRACE_REFRESH_SEARCH_CONDITION = "WMS_SHARE_TRACE_REFRESH_SEARCH_CONDITION";


export const WMS_BUSINESS_FEEDBACK_LOADING = 'WMS_BUSINESS_FEEDBACK_LOADING';
export const WMS_BUSINESS_FEEDBACK_REFRESH_FEEDBACK = "WMS_BUSINESS_FEEDBACK_REFRESH_FEEDBACK";
export const WMS_BUSINESS_FEEDBACK_REFRESH_FEEDBACKS = "WMS_BUSINESS_FEEDBACK_REFRESH_FEEDBACKS";

//商机的成交
export const WMS_BUSINESS_DEAL_LOADING = 'WMS_BUSINESS_DEAL_LOADING';
export const WMS_BUSINESS_DEAL_REFRESH_DEAL = "WMS_BUSINESS_DEAL_REFRESH_DEAL";
export const WMS_BUSINESS_DEAL_REFRESH_FOLLOWER_LIST = "WMS_BUSINESS_DEAL_REFRESH_FOLLOWER_LIST";
export const WMS_BUSINESS_DEAL_REFRESH_DEAL_LEASE = "WMS_BUSINESS_DEAL_REFRESH_DEAL_LEASE";
export const WMS_BUSINESS_DEAL_REFRESH_DEAL_CONTRACT = "WMS_BUSINESS_DEAL_REFRESH_DEAL_CONTRACT";
export const WMS_BUSINESS_DEAL_TOGGLE_CREATE_SELECT_PROPOSAL_MODAL = "WMS_BUSINESS_DEAL_TOGGLE_CREATE_SELECT_PROPOSAL_MODAL";
export const WMS_BUSINESS_DEAL_TOGGLE_CONTRACT_FILE_MODAL = "WMS_BUSINESS_DEAL_TOGGLE_CONTRACT_FILE_MODAL";

export const WMS_BUSINESS_FEE_LOADING = 'WMS_BUSINESS_FEE_LOADING';
export const WMS_BUSINESS_FEE_REFRESH_FEE_TOTAL = "WMS_BUSINESS_FEE_REFRESH_FEE_TOTAL";
export const WMS_BUSINESS_FEE_TOGGLE_FEE_MODAL = "WMS_BUSINESS_FEE_TOGGLE_FEE_MODAL";

export const WMS_BUSINESS_FEE_REFRESH_FEE_LIST = "WMS_BUSINESS_FEE_REFRESH_FEE_LIST";
export const WMS_BUSINESS_FEE_REFRESH_EDIT_FEE_LIST = "WMS_BUSINESS_FEE_REFRESH_EDIT_FEE_LIST";
export const WMS_BUSINESS_FEE_REFRESH_ACHIEVEMENT_RATIO_LIST = "WMS_BUSINESS_FEE_REFRESH_ACHIEVEMENT_RATIO_LIST";
export const WMS_BUSINESS_FEE_REFRESH_EDIT_ACHIEVEMENT_RATIO_LIST = "WMS_BUSINESS_FEE_REFRESH_EDIT_ACHIEVEMENT_RATIO_LIST";

export const WMS_BUSINESS_FEE_TOGGLE_ACHIEVEMENT_RATIO_LIST_MODAL = "WMS_BUSINESS_FEE_TOGGLE_ACHIEVEMENT_RATIO_LIST_MODAL";

export const WMS_BUSINESS_FEE_REFRESH_COMMISSION_LIST = "WMS_BUSINESS_FEE_REFRESH_COMMISSION_LIST";
export const WMS_CONTRACT_LOADING = 'WMS_CONTRACT_LOADING';
export const WMS_CONTRACT_SEARCH_LIST = 'WMS_CONTRACT_SEARCH_LIST';
export const WMS_CONTRACT_SEARCH_ALL_LIST = 'WMS_CONTRACT_SEARCH_ALL_LIST';
export const WMS_CONTRACT_REFRESH_CONTRACT = 'WMS_CONTRACT_REFRESH_CONTRACT';
export const WMS_CONTRACT_REFRESH_BUSINESS_CONTRACT = 'WMS_CONTRACT_REFRESH_BUSINESS_CONTRACT';
export const WMS_CONTRACT_TOGGLE_BUSINESS_CONTRACT_FILE_MODAL = 'WMS_CONTRACT_TOGGLE_BUSINESS_CONTRACT_FILE_MODAL';

export const WMS_CONTRACT_TOGGLE_DETAIL_MODAL = "WMS_CONTRACT_TOGGLE_DETAIL_MODAL";
export const WMS_CONTRACT_REFRESH_SEARCH_CONDITION = "WMS_CONTRACT_REFRESH_SEARCH_CONDITION";


export const WMS_BUSINESS_SERVICE_CONTRACT_LOADING = 'WMS_BUSINESS_SERVICE_CONTRACT_LOADING';
export const WMS_BUSINESS_SERVICE_CONTRACT_REFRESH_CONTRACT = "WMS_BUSINESS_SERVICE_CONTRACT_REFRESH_CONTRACT";
export const WMS_BUSINESS_SERVICE_CONTRACT_REFRESH_CONTRACT_FILE = "WMS_BUSINESS_SERVICE_CONTRACT_REFRESH_CONTRACT_FILE";
export const WMS_BUSINESS_SERVICE_CONTRACT_REFRESH_CONTRACT_INFO = "WMS_BUSINESS_SERVICE_CONTRACT_REFRESH_CONTRACT_INFO";

export const WMS_BUSINESS_SERVICE_CONTRACT_TOGGLE_CONTRACT_INFO_MODAL = "WMS_BUSINESS_SERVICE_CONTRACT_TOGGLE_CONTRACT_INFO_MODAL";

export const WMS_BUSINESS_SERVICE_CONTRACT_TOGGLE_MAIL_HISTORY_MODAL = "WMS_BUSINESS_SERVICE_CONTRACT_TOGGLE_MAIL_HISTORY_MODAL";
export const WMS_BUSINESS_SERVICE_CONTRACT_TOGGLE_CREATE_SELECT_PROPOSAL_MODAL = "WMS_BUSINESS_SERVICE_CONTRACT_TOGGLE_CREATE_SELECT_PROPOSAL_MODAL";

export const WMS_BUSINESS_SERVICE_CONTRACT_TOGGLE_CONTRACT_FILE_MODAL = "WMS_BUSINESS_SERVICE_CONTRACT_TOGGLE_CONTRACT_FILE_MODAL";
export const WMS_BUSINESS_SERVICE_CONTRACT_TOGGLE_LETTER_FORM_MODAL = "WMS_BUSINESS_SERVICE_CONTRACT_TOGGLE_LETTER_FORM_MODAL";

export const WMS_BUSINESS_SERVICE_CONTRACT_REFRESH_LETTER_EDITOR = "WMS_BUSINESS_SERVICE_CONTRACT_REFRESH_LETTER_EDITOR";
export const WMS_BUSINESS_SERVICE_CONTRACT_REFRESH_LETTER_FORM = "WMS_BUSINESS_SERVICE_CONTRACT_REFRESH_LETTER_FORM";

export const WMS_COMMISSION_LOADING = 'WMS_COMMISSION_LOADING';
export const WMS_COMMISSION_SEARCH_LIST = 'WMS_COMMISSION_SEARCH_LIST';
export const WMS_COMMISSION_REFRESH_SEARCH_CONDITION = 'WMS_COMMISSION_REFRESH_SEARCH_CONDITION';

export const WMS_PROPOSAL_REFRESH_READ_PROPOSAL_IDS = 'WMS_PROPOSAL_REFRESH_READ_PROPOSAL_IDS';
export const WMS_PROPOSAL_GROUP_REFRESH_SELECT_PROPOSAL_ID = 'WMS_PROPOSAL_GROUP_REFRESH_SELECT_PROPOSAL_ID';
export const WMS_PROPOSAL_GROUP_REFRESH_READ_PROPOSAL_ID_LIST = 'WMS_PROPOSAL_GROUP_REFRESH_READ_PROPOSAL_ID_LIST';

export const WMS_BUSINESS_SCHEDULER_SHOW_DISTANCE = 'WMS_BUSINESS_SCHEDULER_SHOW_DISTANCE';

export const WMS_TODO_LOADING = 'WMS_TODO_LOADING';
export const WMS_TODO_REFRESH_TODO = "WMS_TODO_REFRESH_FOLLOWUP";
export const WMS_TODO_TOGGLE_CREATE_FOLLOWUP_MODAL = "WMS_TODO_TOGGLE_CREATE_FOLLOWUP_MODAL";
export const WMS_TODO_TOGGLE_DETAIL_FOLLOWUP_MODAL = "WMS_TODO_TOGGLE_DETAIL_FOLLOWUP_MODAL";
export const WMS_TODO_REFRESH_TODO_LIST = "WMS_TODO_REFRESH_TODO_LIST";
export const WMS_TODO_SEARCH_LIST = 'WMS_TODO_SEARCH_LIST';
export const WMS_TODO_STATUS_TOGGLE_TODO_DETAIL_MODAL = 'WMS_TODO_STATUS_TOGGLE_TODO_DETAIL_MODAL';

export const WMS_TODO_STATUS_LOADING = 'WMS_TODO_STATUS_LOADING';
export const WMS_TODO_STATUS_SEARCH_LIST = 'WMS_TODO_STATUS_SEARCH_LIST';
export const WMS_TODO_STATUS_SEARCH_MY_COUNT = 'WMS_TODO_STATUS_SEARCH_MY_COUNT';
export const WMS_TODO_STATUS_REFRESH_TODO_STATUS = 'WMS_TODO_STATUS_REFRESH_TODO_STATUS';
export const WMS_TODO_STATUS_REFRESH_TODO = 'WMS_TODO_STATUS_REFRESH_TODO';

export const WMS_TODO_STATUS_TOGGLE_DETAIL_MODAL = "WMS_TODO_STATUS_TOGGLE_DETAIL_MODAL";
export const WMS_TODO_STATUS_REFRESH_SEARCH_CONDITION = "WMS_TODO_STATUS_REFRESH_SEARCH_CONDITION";

export const WMS_TODO_MY_PUBLISH_ALL_LIST = "WMS_TODO_MY_PUBLISH_ALL_LIST";
export const WMS_TODO_MY_PUBLISH_ALL_SEARCH_CONDITION = "WMS_TODO_MY_PUBLISH_ALL_SEARCH_CONDITION";

export const WMS_TODO_MY_PUBLISH_NEW_LIST = "WMS_TODO_MY_PUBLISH_NEW_LIST";
export const WMS_TODO_MY_PUBLISH_NEW_SEARCH_CONDITION = "WMS_TODO_MY_PUBLISH_NEW_SEARCH_CONDITION";

export const WMS_TODO_MY_PUBLISH_ACCEPT_LIST = "WMS_TODO_MY_PUBLISH_ACCEPT_LIST";
export const WMS_TODO_MY_PUBLISH_ACCEPT_SEARCH_CONDITION = "WMS_TODO_MY_PUBLISH_ACCEPT_SEARCH_CONDITION";

export const WMS_TODO_MY_PUBLISH_REJECT_LIST = "WMS_TODO_MY_PUBLISH_REJECT_LIST";
export const WMS_TODO_MY_PUBLISH_REJECT_SEARCH_CONDITION = "WMS_TODO_MY_PUBLISH_REJECT_SEARCH_CONDITION";

export const WMS_TODO_MY_PUBLISH_COMPLETE_LIST = "WMS_TODO_MY_PUBLISH_COMPLETE_LIST";
export const WMS_TODO_MY_PUBLISH_COMPLETE_SEARCH_CONDITION = "WMS_TODO_MY_PUBLISH_COMPLETE_SEARCH_CONDITION";
export const WMS_TODO_MY_PUBLISH_EXPIRE_LIST = "WMS_TODO_MY_PUBLISH_EXPIRE_LIST";
export const WMS_TODO_MY_PUBLISH_EXPIRE_SEARCH_CONDITION = "WMS_TODO_MY_PUBLISH_EXPIRE_SEARCH_CONDITION";
export const WMS_TODO_MY_PUBLISH_REFRESH_REFRESH_FUNCTION = "WMS_TODO_MY_PUBLISH_REFRESH_REFRESH_FUNCTION";

export const WMS_TODO_MY_PUBLISH_REFRESH_SHOW_STATUS = "WMS_TODO_MY_PUBLISH_REFRESH_SHOW_STATUS";
export const WMS_TODO_TOGGLE_TODO_CREATE_MODAL = 'WMS_TODO_TOGGLE_TODO_CREATE_MODAL';
export const WMS_TODO_TOGGLE_TODO_DETAIL_MODAL = 'WMS_TODO_TOGGLE_TODO_DETAIL_MODAL';
export const WMS_TODO_MY_EXECUTE_SEARCH_ALL_TODO_STATUS_LIST = 'WMS_TODO_MY_EXECUTE_SEARCH_ALL_TODO_STATUS_LIST';

export const WMS_TODO_MY_EXECUTE_SEARCH_WAIT_TODO_STATUS_LIST = 'WMS_TODO_MY_EXECUTE_SEARCH_WAIT_TODO_STATUS_LIST';
export const WMS_TODO_MY_EXECUTE_SEARCH_ACCEPT_TODO_STATUS_LIST = 'WMS_TODO_MY_EXECUTE_SEARCH_ACCEPT_TODO_STATUS_LIST';
export const WMS_TODO_MY_EXECUTE_SEARCH_COMPLETE_TODO_STATUS_LIST = 'WMS_TODO_MY_EXECUTE_SEARCH_COMPLETE_TODO_STATUS_LIST';

export const WMS_TODO_MY_EXECUTE_REFRESH_ALL_SEARCH_CONDITION = 'WMS_TODO_MY_EXECUTE_REFRESH_ALL_SEARCH_CONDITION';
export const WMS_TODO_MY_EXECUTE_REFRESH_WAIT_SEARCH_CONDITION = 'WMS_TODO_MY_EXECUTE_REFRESH_WAIT_SEARCH_CONDITION';
export const WMS_TODO_MY_EXECUTE_REFRESH_ACCEPT_SEARCH_CONDITION = 'WMS_TODO_MY_EXECUTE_REFRESH_ACCEPT_SEARCH_CONDITION';
export const WMS_TODO_MY_EXECUTE_REFRESH_COMPLETE_SEARCH_CONDITION = 'WMS_TODO_MY_EXECUTE_REFRESH_COMPLETE_SEARCH_CONDITION';


export const WMS_TODO_MY_EXECUTE_TOGGLE_TODO_STATUS_DETAIL_MODAL = 'WMS_TODO_MY_EXECUTE_TOGGLE_TODO_STATUS_DETAIL_MODAL';
export const WMS_TODO_MY_EXECUTE_REFRESH_SHOW_STATUS = "WMS_TODO_MY_EXECUTE_REFRESH_SHOW_STATUS";
export const WMS_TODO_MY_EXECUTE_REFRESH_REFRESH_FUNCTION = "WMS_TODO_MY_EXECUTE_REFRESH_REFRESH_FUNCTION";
